import PropTypes from 'prop-types';

import styles from './ReasonLayout.module.scss';

const ReasonLayout = ({ children }) => (
  <section className={styles.reasonLayout}>{children}</section>
);

ReasonLayout.propTypes = {
  children: PropTypes.node,
};

ReasonLayout.defaultProps = {
  children: <div />,
};

export default ReasonLayout;
